// src/components/Icons.js

import React from 'react';
import PropTypes from 'prop-types';

const SonexLogoSvg = ({ fill = 'white' }) => (
    <svg width="153" height="28" viewBox="0 0 153 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_14_59715)">
            <path d="M11.8684 26.0946C9.64926 26.0946 7.57257 25.7281 5.62487 24.9884C3.67718 24.2555 1.99418 23.1969 0.569039 21.8192C0.229719 21.4799 0.0600586 21.093 0.0600586 20.6655C0.0600586 20.1701 0.28401 19.6883 0.738699 19.2404C1.09838 18.8739 1.49199 18.6974 1.92632 18.6974C2.37422 18.6974 2.92394 18.9553 3.55507 19.4779C4.62054 20.4483 5.87598 21.2017 7.33506 21.731C8.79414 22.2671 10.3075 22.5318 11.8684 22.5318C13.3614 22.5318 14.5286 22.2739 15.3633 21.7649C16.1981 21.2559 16.6189 20.5366 16.6189 19.6137C16.6189 18.6432 16.1642 17.8559 15.2616 17.2519C14.359 16.6547 12.8185 16.1186 10.6468 15.6435C7.23327 14.897 4.74946 13.913 3.19537 12.6915C1.64807 11.4699 0.874393 9.89551 0.874393 7.97496C0.874393 6.75341 1.28161 5.66074 2.09598 4.69708C2.91035 3.74019 4.04369 2.99374 5.50276 2.45761C6.96184 1.92827 8.6313 1.66357 10.5111 1.66357C12.6149 1.66357 14.4879 2.00969 16.1234 2.69512C17.7657 3.38733 19.0144 4.35781 19.8763 5.59972C20.1681 6.07477 20.3174 6.4819 20.3174 6.82122C20.2971 7.38449 20.0121 7.87313 19.4691 8.28031C19.1705 8.48391 18.8312 8.58575 18.4512 8.58575C17.7522 8.58575 17.1753 8.31425 16.7206 7.77133C16.0623 6.97733 15.1869 6.35976 14.0875 5.90507C12.9949 5.45039 11.8005 5.22643 10.5111 5.22643C8.90275 5.22643 7.65404 5.47079 6.75823 5.95263C5.86921 6.44125 5.42133 7.11309 5.42133 7.97496C5.42133 8.83005 5.85561 9.54261 6.72427 10.0923C7.59971 10.6488 9.10633 11.1781 11.2576 11.6735C13.6329 12.2368 15.5466 12.8748 16.9921 13.5873C18.4376 14.2999 19.4963 15.1414 20.1614 16.1186C20.8332 17.0891 21.1657 18.2564 21.1657 19.6137C21.1657 20.9031 20.779 22.0363 20.0121 23.0204C19.2452 24.0044 18.1526 24.7645 16.7546 25.2939C15.3498 25.83 13.7211 26.0946 11.8684 26.0946Z" fill="white" />
            <path d="M71.3172 26.0946C70.6385 26.0946 70.0956 25.9114 69.6884 25.5518C69.2812 25.1921 69.0776 24.6898 69.0776 24.0587V11.2663C69.0776 8.25997 70.0142 5.90507 71.894 4.20847C73.7671 2.51187 76.373 1.66357 79.6984 1.66357C83.0237 1.66357 85.6229 2.51187 87.5027 4.20847C89.3758 5.90507 90.3191 8.25997 90.3191 11.2663V24.0587C90.3191 24.6898 90.1155 25.1921 89.7083 25.5518C89.3011 25.9114 88.7582 26.0946 88.0796 26.0946C87.4009 26.0946 86.8513 25.9046 86.4305 25.5314C86.0165 25.1581 85.8061 24.6695 85.8061 24.0587V11.1645C85.8061 9.24398 85.2835 7.77133 84.2452 6.75337C83.2069 5.73541 81.6868 5.22643 79.6984 5.22643C77.7032 5.22643 76.1898 5.73541 75.1515 6.75337C74.1064 7.77133 73.5906 9.24398 73.5906 11.1645V24.0587C73.5906 24.6695 73.3802 25.1581 72.9594 25.5314C72.5455 25.9046 71.9958 26.0946 71.3172 26.0946Z" fill="white" />
            <path d="M138.384 12.1791L132.565 5.19431C132.203 4.76316 132.023 4.27775 132.023 3.73572C132.023 3.39572 132.102 3.07299 132.259 2.76748C132.417 2.46197 132.634 2.23036 132.905 2.07268C133.334 1.82384 133.73 1.69824 134.092 1.69824C134.703 1.69824 135.28 2.02592 135.822 2.68375L142.339 10.5555L148.853 2.68375C149.395 2.02592 149.971 1.69824 150.582 1.69824C150.989 1.69824 151.386 1.82384 151.77 2.07268C152.043 2.23036 152.258 2.46197 152.415 2.76748C152.573 3.07299 152.652 3.39572 152.652 3.73572C152.652 4.27775 152.472 4.76316 152.11 5.19431L144.985 13.7436L152.517 22.8719C152.765 23.1897 152.891 23.5518 152.891 23.9584C152.891 24.3205 152.8 24.6654 152.62 24.9931C152.438 25.3208 152.201 25.5746 151.906 25.7569C151.543 25.9614 151.193 26.0624 150.853 26.0624C150.289 26.0624 149.713 25.7224 149.124 25.0449L142.339 16.8997L142.324 16.9169L138.596 12.4132C138.525 12.3294 138.456 12.2505 138.384 12.1791ZM137.037 16.9613L139.661 20.1124L135.551 25.0449C134.984 25.7224 134.408 26.0624 133.821 26.0624C133.504 26.0624 133.154 25.9614 132.769 25.7569C132.474 25.5746 132.237 25.3208 132.057 24.9931C131.875 24.6654 131.784 24.3205 131.784 23.9584C131.784 23.5518 131.91 23.1897 132.158 22.8719L137.037 16.9613Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M108.23 11.999V12.0105H115.065C115.854 12.0105 116.458 12.1878 116.878 12.5424C117.298 12.897 117.507 13.4032 117.507 14.058C117.507 14.6901 117.292 15.182 116.858 15.5366C116.426 15.8912 115.828 16.0685 115.065 16.0685H108.23V16.0971H105.03C103.903 16.0971 102.994 15.1848 102.994 14.0609V14.0381C102.994 12.9113 103.903 11.999 105.03 11.999H108.23Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M111.438 2.00098V2.01243H121.482C122.271 2.01243 122.874 2.18976 123.295 2.54437C123.715 2.89899 123.924 3.40511 123.924 4.06C123.924 4.69201 123.706 5.18393 123.275 5.53855C122.84 5.89316 122.245 6.07042 121.482 6.07042H111.438V6.09905H105.029C103.905 6.09905 102.993 5.18675 102.993 4.06286V4.04003C102.993 2.91328 103.905 2.00098 105.029 2.00098H111.438Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M111.438 21.9971V22.0085H121.482C122.271 22.0085 122.874 22.1859 123.295 22.5405C123.715 22.8951 123.924 23.4012 123.924 24.0561C123.924 24.6881 123.706 25.18 123.275 25.5346C122.84 25.8893 122.245 26.0665 121.482 26.0665H111.438V26.0951H105.029C103.905 26.0951 102.993 25.1828 102.993 24.059V24.0361C102.993 22.9094 103.905 21.9971 105.029 21.9971H111.438Z" fill="white" />
            <g clip-path="url(#clip1_14_59715)">
                <path d="M39.6043 25.0358C40.3466 25.7673 40.6624 26.5645 39.7859 26.6019C38.0819 26.6745 34.8994 24.301 35.6836 23.542C35.7808 23.4478 35.9337 23.4123 36.0568 23.3842C37.7526 23.2329 39.5858 25.0178 39.6043 25.0358Z" fill="url(#paint0_linear_14_59715)" />
                <path d="M34.096 15.6963C34.4757 17.7047 33.5606 19.0451 32.3779 18.2123C30.8897 17.1642 30.3652 13.4716 32.039 13.047C33.1595 12.9775 33.8955 14.6352 34.096 15.6963Z" fill="url(#paint1_linear_14_59715)" />
                <path d="M40.6235 19.6406C41.4436 21.5583 39.9919 23.0422 38.0341 22.2863C35.8188 21.4307 35.0427 18.5159 36.8132 17.6997C36.8752 17.6712 36.9617 17.6424 37.0251 17.6178C38.727 17.1888 40.1538 18.5425 40.6235 19.6406Z" fill="url(#paint2_linear_14_59715)" />
                <path d="M46.3246 26.4927C46.7632 26.8172 47.1789 27.4102 45.9535 27.5739C44.1341 27.8165 41.9881 26.9331 42.6259 26.2045C42.7542 26.0575 42.9352 25.9904 43.1106 25.9253C44.4152 25.5712 45.7743 26.0853 46.3246 26.4927Z" fill="url(#paint3_linear_14_59715)" />
                <path d="M47.9245 21.9275C48.5548 23.5177 46.5273 25.1688 44.4137 24.2025C42.8625 23.4933 42.6025 21.7487 44.4521 20.8669C46.0986 20.2647 47.5367 20.9487 47.9245 21.9275Z" fill="url(#paint4_linear_14_59715)" />
                <path d="M43.1522 12.3453C43.836 14.4862 41.6938 16.4413 39.7313 15.4673C37.95 14.5836 37.7026 11.746 39.8088 10.7292C41.139 10.1784 42.7014 10.9335 43.1522 12.3453Z" fill="url(#paint5_linear_14_59715)" />
                <path d="M36.8403 9.16689C36.9822 11.3096 35.2611 12.6082 34.2106 11.648C33.0878 10.6215 33.6732 7.71661 35.1184 7.14323C36.0355 6.8624 36.7621 7.98444 36.8403 9.16689Z" fill="url(#paint6_linear_14_59715)" />
                <path d="M34.1584 5.15167C33.453 6.98879 32.6381 7.53746 32.3871 7.10806C31.8527 6.19396 33.8261 3.24524 34.5091 3.1377C34.9245 3.14432 34.1661 5.13154 34.1584 5.15167Z" fill="url(#paint7_linear_14_59715)" />
                <path d="M50.7043 14.9171C51.3954 17.02 49.0672 18.9871 47.0937 17.9672C45.6488 17.2208 45.2469 14.8368 47.3707 13.6169C49.215 12.7866 50.3941 13.9739 50.7043 14.9171Z" fill="url(#paint8_linear_14_59715)" />
                <path d="M53.0346 23.3699C53.0058 24.6746 51.2092 25.6833 50.4011 24.8482C49.9238 24.3551 50.1773 23.3992 51.3152 22.7621C52.5228 22.1987 53.0475 22.7784 53.0346 23.3699Z" fill="url(#paint9_linear_14_59715)" />
                <path d="M39.1349 3.32172C39.4198 4.61808 38.2333 5.65832 37.4547 5.12291C36.6469 4.56736 37.0707 2.66297 37.9002 2.24758C38.5951 2.01033 39.0391 2.88595 39.1349 3.32172Z" fill="url(#paint10_linear_14_59715)" />
                <path d="M44.8911 5.37865C45.7409 6.81282 44.3525 8.18746 42.9032 7.85217C41.2486 7.46953 41.0129 5.35108 42.1891 4.58019C42.2297 4.5534 42.2868 4.52297 42.3289 4.49902C43.4408 3.99983 44.4965 4.71306 44.8911 5.37865Z" fill="url(#paint11_linear_14_59715)" />
                <path d="M55.9268 17.4675C55.9938 18.862 54.7166 20.0842 53.8868 19.4195C53.1932 18.8635 53.3379 17.3253 54.4309 16.5722C55.4072 16.0335 55.8934 16.7713 55.9268 17.4675Z" fill="url(#paint12_linear_14_59715)" />
                <path d="M51.7796 7.4583C52.4977 8.66988 51.6656 10.0178 50.3663 9.74768C48.8915 9.44113 48.3194 7.47048 49.4796 6.69207C49.4824 6.69005 49.4861 6.68779 49.4891 6.6861C50.4989 6.1369 51.4301 6.86831 51.7796 7.4583Z" fill="url(#paint13_linear_14_59715)" />
                <path d="M57.4373 10.2958C57.7237 11.2157 57.2872 12.0445 56.6957 11.7037C56.0721 11.3442 55.8766 9.99301 56.3881 9.57763C56.833 9.27667 57.2833 9.80138 57.4373 10.2958Z" fill="url(#paint14_linear_14_59715)" />
                <path d="M43.9627 0.623121C44.4325 0.921605 44.4401 1.33931 43.9772 1.42105C43.2759 1.54485 42.396 0.815794 42.6497 0.485011C42.6654 0.464628 42.6933 0.443217 42.7141 0.427983C43.0538 0.253591 43.6574 0.42932 43.9627 0.623121Z" fill="url(#paint15_linear_14_59715)" />
                <path d="M50.4852 1.61187C51.0358 2.04108 50.9686 2.50916 50.5146 2.55839C49.8127 2.63497 48.7907 1.7488 49.1302 1.35881C49.1405 1.34698 49.1565 1.33363 49.1675 1.323C49.5208 1.08902 50.1508 1.35108 50.4852 1.61187Z" fill="url(#paint16_linear_14_59715)" />
                <path d="M57.7406 20.2086C57.5035 20.807 57.0575 21.372 56.9834 21.168C56.9092 20.9644 57.2334 19.998 57.6616 19.6229C57.8989 19.4531 57.8749 19.7153 57.8536 19.8359C57.8361 19.9362 57.7948 20.0722 57.7406 20.2086Z" fill="url(#paint17_linear_14_59715)" />
            </g>
        </g>
        <defs>
            <linearGradient id="paint0_linear_14_59715" x1="33.2681" y1="26.801" x2="51.5572" y2="7.58578" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint1_linear_14_59715" x1="33.2682" y1="26.8001" x2="51.5573" y2="7.58492" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint2_linear_14_59715" x1="33.2675" y1="26.8013" x2="51.5566" y2="7.58616" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint3_linear_14_59715" x1="33.2612" y1="26.8014" x2="51.5503" y2="7.58628" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint4_linear_14_59715" x1="33.2692" y1="26.8009" x2="51.5583" y2="7.58573" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint5_linear_14_59715" x1="33.2656" y1="26.8004" x2="51.5547" y2="7.58517" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint6_linear_14_59715" x1="33.2671" y1="26.8" x2="51.5563" y2="7.58483" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint7_linear_14_59715" x1="33.2676" y1="26.8003" x2="51.5567" y2="7.58514" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint8_linear_14_59715" x1="33.2706" y1="26.8008" x2="51.5598" y2="7.58562" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint9_linear_14_59715" x1="33.268" y1="26.8003" x2="51.5572" y2="7.58508" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint10_linear_14_59715" x1="33.2664" y1="26.8002" x2="51.5556" y2="7.58504" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint11_linear_14_59715" x1="33.26" y1="26.801" x2="51.5491" y2="7.58584" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint12_linear_14_59715" x1="33.2656" y1="26.8015" x2="51.5547" y2="7.58634" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint13_linear_14_59715" x1="33.2598" y1="26.8009" x2="51.549" y2="7.58573" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint14_linear_14_59715" x1="33.2619" y1="26.8006" x2="51.5511" y2="7.58539" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint15_linear_14_59715" x1="33.2632" y1="26.8007" x2="51.5523" y2="7.58545" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint16_linear_14_59715" x1="33.262" y1="26.8004" x2="51.5511" y2="7.58532" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <linearGradient id="paint17_linear_14_59715" x1="33.271" y1="26.8007" x2="51.5601" y2="7.58554" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E28A1E" />
                <stop offset="1" stop-color="#E63847" />
            </linearGradient>
            <clipPath id="clip0_14_59715">
                <rect width="153" height="27.3478" fill={fill} transform="translate(0 0.326172)" />
            </clipPath>
            <clipPath id="clip1_14_59715">
                <rect width="26.9757" height="27.3478" fill={fill} transform="translate(30.939 0.326172)" />
            </clipPath>
        </defs>
    </svg>
);

SonexLogoSvg.propTypes = {
    fill: PropTypes.string,
};


const CheckedCalendarSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 4H18V2H16V4H8V2H6V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM5 8V6H19V8H5ZM10.56 18.46L16.49 12.53L15.43 11.47L10.56 16.34L8.45 14.23L7.39 15.29L10.56 18.46Z" fill={fill} />
    </svg>
);

CheckedCalendarSvg.propTypes = {
    fill: PropTypes.string,
};

const CrossedSpoonSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.10023 13.34L10.9302 10.51L3.91023 3.49996C2.35023 5.05996 2.35023 7.58996 3.91023 9.15996L8.10023 13.34ZM14.8802 11.53C16.4102 12.24 18.5602 11.74 20.1502 10.15C22.0602 8.23996 22.4302 5.49996 20.9602 4.02996C19.5002 2.56996 16.7602 2.92996 14.8402 4.83996C13.2502 6.42996 12.7502 8.57996 13.4602 10.11L3.70023 19.87L5.11023 21.28L12.0002 14.41L18.8802 21.29L20.2902 19.88L13.4102 13L14.8802 11.53Z" fill={fill} />
    </svg>
);

CrossedSpoonSvg.propTypes = {
    fill: PropTypes.string,
};

const EventStarSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.6144 17.7956C10.277 18.5682 9.20776 18.5682 8.8704 17.7956L7.99275 15.7854C7.21171 13.9966 5.80589 12.5726 4.0523 11.7942L1.63658 10.7219C0.868536 10.381 0.868537 9.26368 1.63658 8.92276L3.97685 7.88394C5.77553 7.08552 7.20657 5.60881 7.97427 3.75892L8.8633 1.61673C9.19319 0.821768 10.2916 0.821766 10.6215 1.61673L11.5105 3.75894C12.2782 5.60881 13.7092 7.08552 15.5079 7.88394L17.8482 8.92276C18.6162 9.26368 18.6162 10.381 17.8482 10.7219L15.4325 11.7942C13.6789 12.5726 12.2731 13.9966 11.492 15.7854L10.6144 17.7956ZM4.53956 9.82234C6.8254 10.837 8.68402 12.5048 9.74238 14.7996C10.8008 12.5048 12.6594 10.837 14.9452 9.82234C12.6321 8.79557 10.7676 7.04647 9.74239 4.71088C8.71719 7.04648 6.85267 8.79557 4.53956 9.82234ZM19.4014 22.6899L19.6482 22.1242C20.0882 21.1156 20.8807 20.3125 21.8695 19.8732L22.6299 19.5353C23.0412 19.3526 23.0412 18.7549 22.6299 18.5722L21.9121 18.2532C20.8978 17.8026 20.0911 16.9698 19.6586 15.9269L19.4052 15.3156C19.2285 14.8896 18.6395 14.8896 18.4628 15.3156L18.2094 15.9269C17.777 16.9698 16.9703 17.8026 15.956 18.2532L15.2381 18.5722C14.8269 18.7549 14.8269 19.3526 15.2381 19.5353L15.9985 19.8732C16.9874 20.3125 17.7798 21.1156 18.2198 22.1242L18.4667 22.6899C18.6473 23.104 19.2207 23.104 19.4014 22.6899ZM18.3745 19.0469L18.937 18.4883L19.4878 19.0469L18.937 19.5898L18.3745 19.0469Z" fill={fill} />
    </svg>
);

EventStarSvg.propTypes = {
    fill: PropTypes.string,
};

const TicketVerticalSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2.01 4.89 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM11 15H13V17H11V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7Z" fill={fill} />
    </svg>
);

TicketVerticalSvg.propTypes = {
    fill: PropTypes.string,
};

const SettingGearSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.4298 12.98C19.4698 12.66 19.4998 12.34 19.4998 12C19.4998 11.66 19.4698 11.34 19.4298 11.02L21.5398 9.37C21.7298 9.22 21.7798 8.95 21.6598 8.73L19.6598 5.27C19.5698 5.11 19.3998 5.02 19.2198 5.02C19.1598 5.02 19.0998 5.03 19.0498 5.05L16.5598 6.05C16.0398 5.65 15.4798 5.32 14.8698 5.07L14.4898 2.42C14.4598 2.18 14.2498 2 13.9998 2H9.99984C9.74984 2 9.53984 2.18 9.50984 2.42L9.12984 5.07C8.51984 5.32 7.95984 5.66 7.43984 6.05L4.94984 5.05C4.88984 5.03 4.82984 5.02 4.76984 5.02C4.59984 5.02 4.42984 5.11 4.33984 5.27L2.33984 8.73C2.20984 8.95 2.26984 9.22 2.45984 9.37L4.56984 11.02C4.52984 11.34 4.49984 11.67 4.49984 12C4.49984 12.33 4.52984 12.66 4.56984 12.98L2.45984 14.63C2.26984 14.78 2.21984 15.05 2.33984 15.27L4.33984 18.73C4.42984 18.89 4.59984 18.98 4.77984 18.98C4.83984 18.98 4.89984 18.97 4.94984 18.95L7.43984 17.95C7.95984 18.35 8.51984 18.68 9.12984 18.93L9.50984 21.58C9.53984 21.82 9.74984 22 9.99984 22H13.9998C14.2498 22 14.4598 21.82 14.4898 21.58L14.8698 18.93C15.4798 18.68 16.0398 18.34 16.5598 17.95L19.0498 18.95C19.1098 18.97 19.1698 18.98 19.2298 18.98C19.3998 18.98 19.5698 18.89 19.6598 18.73L21.6598 15.27C21.7798 15.05 21.7298 14.78 21.5398 14.63L19.4298 12.98ZM17.4498 11.27C17.4898 11.58 17.4998 11.79 17.4998 12C17.4998 12.21 17.4798 12.43 17.4498 12.73L17.3098 13.86L18.1998 14.56L19.2798 15.4L18.5798 16.61L17.3098 16.1L16.2698 15.68L15.3698 16.36C14.9398 16.68 14.5298 16.92 14.1198 17.09L13.0598 17.52L12.8998 18.65L12.6998 20H11.2998L10.9498 17.52L9.88984 17.09C9.45984 16.91 9.05984 16.68 8.65984 16.38L7.74984 15.68L6.68984 16.11L5.41984 16.62L4.71984 15.41L5.79984 14.57L6.68984 13.87L6.54984 12.74C6.51984 12.43 6.49984 12.2 6.49984 12C6.49984 11.8 6.51984 11.57 6.54984 11.27L6.68984 10.14L5.79984 9.44L4.71984 8.6L5.41984 7.39L6.68984 7.9L7.72984 8.32L8.62984 7.64C9.05984 7.32 9.46984 7.08 9.87984 6.91L10.9398 6.48L11.0998 5.35L11.2998 4H12.6898L13.0398 6.48L14.0998 6.91C14.5298 7.09 14.9298 7.32 15.3298 7.62L16.2398 8.32L17.2998 7.89L18.5698 7.38L19.2698 8.59L18.1998 9.44L17.3098 10.14L17.4498 11.27ZM11.9998 8C9.78984 8 7.99984 9.79 7.99984 12C7.99984 14.21 9.78984 16 11.9998 16C14.2098 16 15.9998 14.21 15.9998 12C15.9998 9.79 14.2098 8 11.9998 8ZM11.9998 14C10.8998 14 9.99984 13.1 9.99984 12C9.99984 10.9 10.8998 10 11.9998 10C13.0998 10 13.9998 10.9 13.9998 12C13.9998 13.1 13.0998 14 11.9998 14Z" fill={fill} />
    </svg>
);

SettingGearSvg.propTypes = {
    fill: PropTypes.string,
};

const ExpandedFileSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z" fill={fill} />
    </svg>
);

ExpandedFileSvg.propTypes = {
    fill: PropTypes.string,
};


const ProfileSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 22C4 19.9793 4.80272 18.0414 6.23157 16.6125C7.66042 15.1837 9.59835 14.381 11.619 14.381C13.6397 14.381 15.5777 15.1837 17.0065 16.6125C18.4354 18.0414 19.2381 19.9793 19.2381 22H17.3333C17.3333 20.4845 16.7313 19.031 15.6597 17.9594C14.588 16.8878 13.1346 16.2857 11.619 16.2857C10.1035 16.2857 8.65007 16.8878 7.57844 17.9594C6.5068 19.031 5.90476 20.4845 5.90476 22H4ZM11.619 13.4286C8.4619 13.4286 5.90476 10.8714 5.90476 7.71429C5.90476 4.55714 8.4619 2 11.619 2C14.7762 2 17.3333 4.55714 17.3333 7.71429C17.3333 10.8714 14.7762 13.4286 11.619 13.4286ZM11.619 11.5238C13.7238 11.5238 15.4286 9.81905 15.4286 7.71429C15.4286 5.60952 13.7238 3.90476 11.619 3.90476C9.51429 3.90476 7.80952 5.60952 7.80952 7.71429C7.80952 9.81905 9.51429 11.5238 11.619 11.5238Z" fill={fill} />
    </svg>
);

ProfileSvg.propTypes = {
    fill: PropTypes.string,
};

const LogOutSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z" fill={fill} />
    </svg>
);

LogOutSvg.propTypes = {
    fill: PropTypes.string,
};

const ArrowHeadUpSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 8.29492L6 14.2949L7.41 15.7049L12 11.1249L16.59 15.7049L18 14.2949L12 8.29492Z" fill={fill} />
    </svg>
);

ArrowHeadUpSvg.propTypes = {
    fill: PropTypes.string,
};

const ArrowHeadDownSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.59 8.29492L12 12.8749L7.41 8.29492L6 9.70492L12 15.7049L18 9.70492L16.59 8.29492Z" fill={fill} />
    </svg>
);

ArrowHeadDownSvg.propTypes = {
    fill: PropTypes.string,
};


const MagnifyGlassSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.2049 15.952L21 19.7462L19.7462 21L15.952 17.2049C14.5402 18.3366 12.7842 18.9522 10.9748 18.9496C6.57271 18.9496 3 15.3769 3 10.9748C3 6.57271 6.57271 3 10.9748 3C15.3769 3 18.9496 6.57271 18.9496 10.9748C18.9522 12.7842 18.3366 14.5402 17.2049 15.952ZM15.4274 15.2945C16.5519 14.138 17.18 12.5879 17.1774 10.9748C17.1774 7.54741 14.4013 4.77218 10.9748 4.77218C7.54741 4.77218 4.77218 7.54741 4.77218 10.9748C4.77218 14.4013 7.54741 17.1774 10.9748 17.1774C12.5879 17.18 14.138 16.5519 15.2945 15.4274L15.4274 15.2945Z" fill={fill} />
    </svg>
);

MagnifyGlassSvg.propTypes = {
    fill: PropTypes.string,
};

const SeeSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill={fill} />
    </svg>


);

SeeSvg.propTypes = {
    fill: PropTypes.string,
};

const LeftArrowSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z" fill={fill} />
    </svg>

);

LeftArrowSvg.propTypes = {
    fill: PropTypes.string,
};

const RightArrowSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z" fill={fill} />
    </svg>


);

RightArrowSvg.propTypes = {
    fill: PropTypes.string,
};


const ExpandSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6V8H4V19H15V14H17V20C17 20.5523 16.5523 21 16 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6H9ZM20 3V11H18L17.9999 6.413L10.2071 14.2071L8.79289 12.7929L16.5849 5H12V3H20Z" fill={fill} />
    </svg>


);

ExpandSvg.propTypes = {
    fill: PropTypes.string,
};


const PenSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z" fill={fill} />
    </svg>



);

PenSvg.propTypes = {
    fill: PropTypes.string,
};


const TrashSvg = ({ fill = 'white' }) => (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z" fill={fill} />
    </svg>

);

TrashSvg.propTypes = {
    fill: PropTypes.string,
};

const NoSvg = ({ fill1 = 'black', fill2 = 'white' }) => (
    < svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <circle cx="12" cy="12" r="10" fill={fill1} />
        <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 10.586L9.172 7.757L7.757 9.172L10.586 12L7.757 14.828L9.172 16.243L12 13.414L14.828 16.243L16.243 14.828L13.414 12L16.243 9.172L14.828 7.757L12 10.586Z" fill={fill2} />
    </svg >
);

NoSvg.propTypes = {
    fill1: PropTypes.string,
    fill2: PropTypes.string,
};


const YesSvg = ({ fill = 'white' }) => (
    < svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11.003 16L18.073 8.929L16.659 7.515L11.003 13.172L8.174 10.343L6.76 11.757L11.003 16Z" fill={fill} />
    </svg >

);

YesSvg.propTypes = {
    fill: PropTypes.string,
};

const WarningSvg = ({ fill1 = 'black', fill2 = 'white' }) => (

    < svg svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <g clip-path="url(#clip0_14_63403)">
            <path d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z" fill={fill1} />
        </g>
        <defs>
            <clipPath id="clip0_14_63403">
                <rect width="24" height="24" fill={fill2} />
            </clipPath>
        </defs>
    </svg >
);

WarningSvg.propTypes = {
    fill1: PropTypes.string,
    fill2: PropTypes.string,
};

const XSvg = ({ fill = 'white' }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill={fill} />
    </svg>
);

XSvg.propTypes = {
    fill1: PropTypes.string,
    fill2: PropTypes.string,
};

const AllDatesSvg = ({ fill = 'white' }) => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 4H21C21.2652 4 21.5196 4.10536 21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H7V2H9V4H15V2H17V4ZM20 12H4V20H20V12ZM15 6H9V8H7V6H4V10H20V6H17V8H15V6ZM6 14H8V16H6V14ZM11 14H13V16H11V14ZM16 14H18V16H16V14Z" fill={fill} />
    </svg>

);

AllDatesSvg.propTypes = {
    fill1: PropTypes.string,
    fill2: PropTypes.string,
};



const RealLeftArrowSvg = ({ fill = 'white' }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill={fill} />
    </svg>

);

RealLeftArrowSvg.propTypes = {
    fill1: PropTypes.string,
    fill2: PropTypes.string,
};


const TwinSvg = ({ fill = 'white' }) => (
    <svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.2381 22.0715V19.7382C25.2381 17.5637 23.7509 15.7366 21.7381 15.2186M17.6548 1.41075C19.365 2.10304 20.5715 3.77973 20.5715 5.7382C20.5715 7.69667 19.365 9.37336 17.6548 10.0656M19.4048 22.0715C19.4048 19.8971 19.4048 18.8099 19.0496 17.9523C18.5759 16.8089 17.6674 15.9004 16.524 15.4268C15.6664 15.0715 14.5792 15.0715 12.4048 15.0715H8.90478C6.73039 15.0715 5.64319 15.0715 4.7856 15.4268C3.64213 15.9004 2.73365 16.8089 2.26001 17.9523C1.90479 18.8099 1.90479 19.8971 1.90479 22.0715M15.3215 5.7382C15.3215 8.31553 13.2321 10.4049 10.6548 10.4049C8.07746 10.4049 5.98812 8.31553 5.98812 5.7382C5.98812 3.16087 8.07746 1.07153 10.6548 1.07153C13.2321 1.07153 15.3215 3.16087 15.3215 5.7382Z" stroke={fill} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

);

TwinSvg.propTypes = {
    fill: PropTypes.string,
};


const ClockWithHandsSvg = ({ fill = 'white' }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_178_3082)">
            <path d="M21.867 31.9997H21.823C21.4856 31.9942 21.1527 31.9205 20.8445 31.783C20.5363 31.6456 20.2592 31.4471 20.0297 31.1997L15.8057 26.8504L17.7337 25.0077L21.8737 29.2744L29.9817 21.165L31.867 23.0464L23.6523 31.2624C23.4186 31.4977 23.1404 31.684 22.8338 31.8106C22.5273 31.9372 22.1986 32.0015 21.867 31.9997Z" fill={fill} />
            <path d="M14.6665 8V14.1147L11.0571 17.724L12.9425 19.6093L17.3331 15.2187V8H14.6665Z" fill={fill} />
            <path d="M16.0002 0C11.8956 0.0344113 7.96125 1.645 5.01079 4.49867C2.06033 7.35234 0.319464 11.2308 0.14822 15.3319C-0.0230246 19.4331 1.38845 23.4432 4.09074 26.5329C6.79303 29.6226 10.5794 31.5555 14.6668 31.932V29.2653C12.04 29.0034 9.54996 27.9681 7.51172 26.2906C5.47347 24.613 3.97866 22.3685 3.21642 19.8411C2.45418 17.3138 2.45879 14.6171 3.22964 12.0923C4.0005 9.56754 5.50297 7.32817 7.54693 5.65757C9.59089 3.98697 12.0845 2.96023 14.7121 2.70725C17.3398 2.45428 19.9835 2.98645 22.3086 4.23643C24.6337 5.4864 26.5358 7.398 27.7742 9.72933C29.0126 12.0607 29.5316 14.707 29.2655 17.3333H31.9322C31.9695 16.892 32.0002 16.4507 32.0002 16C31.9956 11.7579 30.3084 7.69095 27.3088 4.69136C24.3092 1.69177 20.2422 0.00458811 16.0002 0Z" fill={fill} />
        </g>
        <defs>
            <clipPath id="clip0_178_3082">
                <rect width="32" height="32" fill={fill} />
            </clipPath>
        </defs>
    </svg>

);

ClockWithHandsSvg.propTypes = {
    fill: PropTypes.string,
};


const ShieldSvg = ({ fill = 'white' }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_178_3090)">
            <path d="M29.4099 8.23942C29.3935 7.37546 29.3778 6.55929 29.3778 5.76971C29.3778 5.15113 28.8764 4.64963 28.2577 4.64963C23.4675 4.64963 19.8203 3.27297 16.7803 0.317151C16.3454 -0.105792 15.6533 -0.105642 15.2186 0.317151C12.1788 3.27297 8.5323 4.64963 3.74238 4.64963C3.1238 4.64963 2.6223 5.15113 2.6223 5.76971C2.6223 6.55944 2.60677 7.37591 2.59019 8.24002C2.43666 16.2801 2.22639 27.2914 15.6326 31.9383C15.7515 31.9795 15.8754 32.0001 15.9994 32.0001C16.1233 32.0001 16.2474 31.9795 16.3662 31.9383C29.7734 27.2913 29.5634 16.2797 29.4099 8.23942ZM15.9995 29.6914C4.50194 25.5147 4.67578 16.3651 4.83005 8.28273C4.83931 7.79766 4.84827 7.32752 4.85455 6.86664C9.34085 6.67728 12.9284 5.31779 15.9995 2.64244C19.0709 5.31779 22.6591 6.67743 27.1457 6.86664C27.1519 7.32737 27.1609 7.79721 27.1702 8.28198C27.3243 16.3646 27.498 25.5145 15.9995 29.6914Z" fill={fill} />
            <path d="M19.8565 12.1092L14.4504 17.5151L12.1435 15.2081C11.706 14.7709 10.9968 14.7709 10.5595 15.2081C10.1221 15.6457 10.1221 16.3548 10.5595 16.7922L13.6584 19.8911C13.8771 20.1098 14.1638 20.2191 14.4504 20.2191C14.737 20.2191 15.0237 20.1098 15.2424 19.8911L21.4403 13.6933C21.8779 13.2559 21.8779 12.5467 21.4404 12.1094C21.0032 11.672 20.2939 11.6718 19.8565 12.1092Z" fill={fill} />
        </g>
        <defs>
            <clipPath id="clip0_178_3090">
                <rect width="32" height="32" fill={fill} />
            </clipPath>
        </defs>
    </svg>


);

ShieldSvg.propTypes = {
    fill: PropTypes.string,
};



const RecArrowsSvg = ({ fill = 'white' }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M29.537 3.69269V7.48826C27.9195 4.91071 25.5999 2.84841 22.8507 1.54373C20.1016 0.239043 17.0372 -0.25381 14.0176 0.123091C10.998 0.499991 8.14868 1.73098 5.80457 3.6714C3.46047 5.61181 1.71895 8.18102 0.784668 11.0771H3.39628C4.34294 8.64623 5.97253 6.54111 8.08858 5.01551C10.2046 3.48991 12.7168 2.60895 15.3222 2.47887C17.9277 2.34878 20.5151 2.9751 22.7726 4.28234C25.0301 5.58957 26.8613 7.52189 28.0454 9.84634H23.3834V12.3078H31.9985V3.69269H29.537Z" fill={fill} />
        <path d="M15.9995 29.5382C13.5063 29.536 11.0621 28.8453 8.93652 27.5423C6.8109 26.2393 5.08638 24.3746 3.95311 22.1538H8.61512V19.6924H0V28.3075H2.46146V24.5119C4.07895 27.0895 6.39857 29.1518 9.14772 30.4565C11.8969 31.7611 14.9613 32.254 17.9809 31.8771C21.0005 31.5002 23.8498 30.2692 26.1939 28.3288C28.538 26.3884 30.2795 23.8192 31.2138 20.9231H28.6022C27.6143 23.4618 25.8824 25.6428 23.6335 27.1801C21.3846 28.7174 18.7236 29.5394 15.9995 29.5382Z" fill={fill} />
    </svg>
);

RecArrowsSvg.propTypes = {
    fill: PropTypes.string,
};







export { RecArrowsSvg, ShieldSvg, ClockWithHandsSvg, TwinSvg, RealLeftArrowSvg, AllDatesSvg, SonexLogoSvg, CheckedCalendarSvg, CrossedSpoonSvg, EventStarSvg, TicketVerticalSvg, SettingGearSvg, ExpandedFileSvg, ProfileSvg, LogOutSvg, ArrowHeadUpSvg, ArrowHeadDownSvg, MagnifyGlassSvg, SeeSvg, LeftArrowSvg, RightArrowSvg, ExpandSvg, PenSvg, TrashSvg, NoSvg, YesSvg, WarningSvg, XSvg };
